import React from 'react';
import mp3 from '@/assets/sounds/npr20160621.mp3';

class AudioDetector extends React.Component {
  constructor() {
    super();
    this.audio = React.createRef();
  }

  handlePlay = () => {
    this.audio.current.play();
  }

  render = () => (
    <div className="audio-wrapper">
      <div className="audio-explain">If you can hear this message, your speakers are working fine.</div>
      <div className="audio-play-btn" onClick={this.handlePlay} />
      <audio src={mp3} style={{ display: 'none' }} ref={this.audio} />
    </div>
  );
}

export default AudioDetector;
